module.exports = __webpack_public_path__ + "static/media/bakaefing_small.94ef900e.png";